import { Component, inject, input, Input } from '@angular/core';
import { MinimalRegionDto } from '@artemis-software/wr-api';
import { Router } from '@angular/router';
import { Tracked } from '@/utils/signals/tracked';

@Component({
  standalone: false,
  selector: 'wr-region-badge',
  templateUrl: './region-badge.component.html',
  styleUrls: ['./region-badge.component.scss']
})
export class RegionBadgeComponent {
  readonly router = inject(Router);

  readonly region = input<MinimalRegionDto>();

  @Input()
  @Tracked()
  disableLink = false;
}
